const ProductPreviews = () => {
  return (
    <div className="product-previews">
      <div className="product-previews__headline">
        <p>
          <span> No registration needed to start</span>—just dive right in. For
          streamers and podcasters, <span>go live</span> and share your voice
          instantly. For listeners, browse unique frequencies and{" "}
          <span>tune into streams and podcasts</span>—all without sign-up
          hassle.
        </p>
      </div>
      <div className="product-previews__picture">
        <picture>
          <source
            /* Mobile */
            media="(max-width: 480px)"
            sizes="390px"
            srcSet="
              /assets/pictures/product/product-previews--mobile-390-1x.webp 390w,
              /assets/pictures/product/product-previews--mobile-780-2x.webp 780w,
              /assets/pictures/product/product-previews--mobile-1170-3x.webp 1170w,
              /assets/pictures/product/product-previews--mobile-1560-4x.webp 1560w"
          />
          <source
            /* Tablet */
            media="(max-width: 1024px)"
            sizes="576px"
            srcSet="
              /assets/pictures/product/product-previews--tablet-576-1x.webp 576w,
              /assets/pictures/product/product-previews--tablet-1152-2x.webp 1152w,
              /assets/pictures/product/product-previews--tablet-1728-3x.webp 1728w,
              /assets/pictures/product/product-previews--tablet-2304-4x.webp 2304w"
          />

          <source
            /* Desktop */

            media="(min-width: 1025px)"
            sizes="728px"
            srcSet="
              /assets/pictures/product/product-previews--desktop-728-1x.webp 728w,
              /assets/pictures/product/product-previews--desktop-1456-2x.webp 1456w,
              /assets/pictures/product/product-previews--desktop-2184-3x.webp 2184w,
              /assets/pictures/product/product-previews--desktop-2912-4x.webp 2912w"
          />
          <img
            /* Fallback */
            loading="lazy"
            src="/assets/pictures/product/product-previews--desktop-728-1x.webp"
            alt="product preview pictures"
          />
        </picture>
      </div>
    </div>
  );
};

export default ProductPreviews;
